(function () {
    if (customElements.get('aztable-items')) return;

    function searchText(value) {
        return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim().replace(/\s+/g, ' ');
    }

    class AZTable extends HTMLElement {
        connectedCallback() {
            if (this.initialized) { this.observeEdges(); return; }
            this.azTable = this.querySelector('#haloAZTable');
            this.azWrapper = this.querySelector('#haloAZWrapper');
            if (!this.azTable || !this.azWrapper) return;

            this.groups = Array.from(this.azWrapper.querySelectorAll('.az-group')).map(group => ({
                node: group,
                letter: group.dataset.letter,
                brands: Array.from(group.querySelectorAll('.az-group-list > li.brand')).map(item => ({
                    node: item,
                    name: searchText(item.textContent)
                }))
            }));
            this.form = this.querySelector('[data-brand-search]');
            this.input = this.querySelector('[data-brand-search-input]');
            this.clear = this.querySelector('[data-brand-search-clear]');
            this.status = this.querySelector('[data-brand-search-status]');
            this.empty = this.querySelector('[data-brand-search-empty]');
            this.query = '';
            this.letter = 'all';

            this.azTable.querySelectorAll('li[data-letter]').forEach(item => {
                const enabled = item.dataset.letter === 'all' || this.groups.some(group => group.letter === item.dataset.letter && group.brands.length);
                item.classList.toggle('disable', !enabled);
                item.classList.toggle('has-letter', enabled && item.dataset.letter !== 'all');
                const link = item.querySelector('a');
                if (link) {
                    link.setAttribute('aria-disabled', String(!enabled));
                    if (!enabled) link.setAttribute('tabindex', '-1');
                }
            });

            this.azTable.addEventListener('click', event => this.onClickHandler(event));
            this.azTable.addEventListener('keydown', event => {
                if (event.key === ' ' && event.target.closest('a')) {
                    event.preventDefault();
                    event.target.closest('a').click();
                }
            });
            if (this.form && this.input && this.clear && this.status && this.empty) {
                this.form.addEventListener('submit', event => { event.preventDefault(); this.onSearch(); });
                this.input.addEventListener('input', () => this.onSearch());
                this.input.addEventListener('search', () => this.onSearch());
                this.input.addEventListener('keydown', event => {
                    if (event.key === 'Escape' && this.input.value) { event.preventDefault(); this.clearSearch(); }
                });
                this.clear.addEventListener('click', () => this.clearSearch());
                this.form.hidden = false;
            }
            this.initialized = true;
            this.activeBrand();
            this.applyFilters();
            this.observeEdges();
        }

        disconnectedCallback() {
            if (this.edgeObserver) { this.edgeObserver.disconnect(); this.edgeObserver = null; }
        }

        activeBrand() {
            const hash = window.location.hash.slice(1).toLowerCase().replace(/^az-code-/, '');
            const item = Array.from(this.azTable.querySelectorAll('li[data-letter]')).find(link => link.dataset.letter === hash && !link.classList.contains('disable'));
            if (item) this.letter = item.dataset.letter;
        }

        onClickHandler(event) {
            const link = event.target.closest('a');
            if (!link || !this.azTable.contains(link)) return;
            event.preventDefault();
            const item = link.closest('li[data-letter]');
            if (!item || item.classList.contains('disable')) return;
            /* A-Z browsing and all-brand search are separate modes. */
            this.letter = item.dataset.letter;
            this.query = '';
            if (this.input) this.input.value = '';
            this.applyFilters();
            const top = this.azWrapper.getBoundingClientRect().top + (window.scrollY || document.documentElement.scrollTop);
            const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
        }

        onSearch() {
            this.query = searchText(this.input.value);
            this.letter = 'all';
            this.applyFilters();
        }

        clearSearch() {
            this.input.value = '';
            this.onSearch();
            this.input.focus();
        }

        applyFilters() {
            let count = 0;
            this.azWrapper.classList.toggle('active-all', this.letter === 'all');
            this.azTable.querySelectorAll('li[data-letter]').forEach(item => {
                const active = item.dataset.letter === this.letter;
                item.classList.toggle('is-active', active);
                const link = item.querySelector('a');
                if (link) link.setAttribute('aria-pressed', String(active));
            });
            this.groups.forEach(group => {
                let visible = 0;
                const selected = this.letter === 'all' || group.letter === this.letter;
                group.brands.forEach(brand => {
                    const match = selected && (!this.query || brand.name.includes(this.query));
                    brand.node.hidden = !match;
                    if (match) visible++;
                });
                group.node.hidden = visible === 0;
                group.node.classList.toggle('hide', group.brands.length === 0);
                group.node.classList.toggle('is-active', this.letter !== 'all' && group.letter === this.letter);
                count += visible;
            });
            if (this.clear) this.clear.disabled = !this.input.value;
            if (this.status) {
                const template = this.status.dataset.countTemplate;
                if (template) {
                    const message = template.replace('__COUNT__', String(count));
                    if (this.status.textContent !== message) this.status.textContent = message;
                }
            }
            if (this.empty) this.empty.hidden = !this.query || count !== 0;
        }

        observeEdges() {
            const wrapper = this.querySelector('.wrapper-AZTable');
            if (!wrapper || this.edgeObserver || !window.IntersectionObserver) return;
            const items = Array.from(this.azTable.querySelectorAll('li:not(.disable)'));
            if (!items.length) return;
            const first = items[0], last = items[items.length - 1];
            const rtl = window.getComputedStyle(this).direction === 'rtl';
            wrapper.classList.add('initialized');
            this.edgeObserver = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.target === first) wrapper.classList.toggle(rtl ? 'disable-last' : 'disable-first', entry.isIntersecting);
                    if (entry.target === last) wrapper.classList.toggle(rtl ? 'disable-first' : 'disable-last', entry.isIntersecting);
                });
            }, { root: this.azTable, threshold: 0.6 });
            this.edgeObserver.observe(first);
            if (last !== first) this.edgeObserver.observe(last);
        }
    }

    customElements.define('aztable-items', AZTable);
})();
